import type { MissingField, RfpBenefitPlan } from "@platform/plan-grid-core";

const PLAN_LEVEL_FIELD_KEY = "planLevel";
const PLAN_LEVEL_FIELD_LABEL = "Plan Level";

/**
 * Plan Level (optionName) is metadata on the plan itself, not a benefit
 * definition, so `validateRequiredFields` never sees it. This produces the
 * equivalent MissingField entries so an unset Plan Level blocks Mark Complete
 * the same way a missing benefit-definition field does.
 *
 * Call this only where the inline Plan Level dropdown actually renders (the
 * doc-map column path) — UtilityBar's `isPlanLevelDropdownEnabled` gates it,
 * since normal/benchmark BTX modes have no UI to clear the requirement.
 */
export const getMissingPlanLevelFields = (
  benefitPlans: RfpBenefitPlan[],
): MissingField[] =>
  benefitPlans
    .filter((plan) => !plan.optionName)
    .map((plan) => ({
      fieldKey: PLAN_LEVEL_FIELD_KEY,
      label: PLAN_LEVEL_FIELD_LABEL,
      planIdentifier: plan.identifier,
    }));
